import React, { useEffect, useState } from "react";
import imgCardCards from "./type_image/cards.png";
import imgCarRub from "./type_image/rub.png";
import imgCardSber from "./type_image/sberPay.png";
import imgCardSbp from "./type_image/sbp.png";
import imgCardUsdt from "./type_image/usdt.png";
import imgCardHumo from "./type_image/humo.png";
import imgCardUzcard from "./type_image/uzcard.png";
import imgQrcode from "./type_image/qrcode.png";
import imgKapitalBank from "./type_image/kb.png";
import imgM10 from "./type_image/m10.png";
import imgVisaMc from "./type_image/visaMC.png";
import imgAlfa from "./type_image/alfa.png";
import imgACC from "./type_image/acc.png";
import imgLemon from "./type_image/lemon.png";
import imgMpay from "./type_image/mpay.png";
import imgBitcoin from "./type_image/crypto/bitCoin.png";
import imgBitcoinHash from "./type_image/crypto/bitCoinHash.png";
import imgLiteCoin from "./type_image/crypto/liteCoin.png";
import imgMonero from "./type_image/crypto/monero.png";
import imgTron from "./type_image/crypto/tron.png";
import "./top-up-cards.scss";
import { API_USER } from "../../../../api/user";
import { DEBUG, ENUM_BALANCE_TYPE, ENUM_CURRENCY, TEST_MODE } from "../../../../store/enums";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../../mui/loader_container/LoaderContainer";

import { setLockBalanceClose } from "../../../../store/siteSlice.js";
import { useDispatch } from "react-redux";
import { testCryptoWallet } from "../../../../store/testConst.js";
import ShowContainer from "../../../mui/ShowContainer.jsx";

const cryptoType = "crypgt";

export default function TopUpCards({ amount, currency, setMethodDataPay, setStep }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [cards, setCard] = useState([]);
  const [cryptoCard, setCryptoCard] = useState([]);
  const [loader, setLoader] = useState(false);

  const cardsByIdCommon = {
    sber: { id: "sber", img: imgCardSber, title: "To Sberbank account" },
    rub: { id: "rub", img: imgCarRub, title: "Transfer to account" },
    usdt: { id: "usdt", img: imgCardUsdt, title: "USDT" },
    qrc: { id: "qrc", img: imgQrcode, title: "QR code" },
    sbp: { id: "sbp", img: imgCardSbp, title: "SBP by phone number" },
    acc: { id: "acc", img: imgACC, title: "Transfer by bank details" },
    "card.LEMON": { id: "card.LEMON", img: imgLemon, title: "Lemon" }
  };

  const cardsById = {
    ...cardsByIdCommon,
    card: { id: "card", img: imgCardCards, title: "Transfer to bank card" },
    "card.HUMO": { id: "card.HUMO", img: imgCardHumo, title: "Humo" },
    "card.UZCARD": { id: "card.UZCARD", img: imgCardUzcard, title: "Uzcard" },
    "sbp.m10": { id: "sbp.m10", img: imgM10, title: "M10" },
    "sbp.mpay": { id: "sbp.mpay", img: imgMpay, title: "MPAY" },
    kapitalBank: { id: "kapitalBank", img: imgKapitalBank, title: "Transfer to Kapital Bank card" },
    // visaMc: { id: "card.visa", img: imgVisaMc, title: "Transfer to bank card" },
    visaMc: { id: "card", img: imgVisaMc, title: "Transfer to bank card" },
    alpha: { id: "alpha", img: imgAlfa, title: "Alpha Bank clients" }
  };

  const cryptoImgByTicker = {
    BTC: imgBitcoin,
    BCH: imgBitcoinHash,
    LTC: imgLiteCoin,
    XMR: imgMonero,
    TRX: imgTron
  };

  const cryptoTitleByTicker = {
    BTC: "Bitcoin",
    BCH: "Bitcoin Cash",
    LTC: "Litecoin",
    XMR: "Monero",
    TRX: "TRON TRC20 (USDT)"
  };

  const addMethodAZN = (list) => {
    const newCards = list?.map((el) => cardsByIdCommon[el]) || [];

    if (list.includes("card")) {
      newCards.push({ ...cardsById.visaMc, id: "card" });
      newCards.push({ ...cardsById.kapitalBank, id: "card" });
    }

    if (list.includes("sbp.m10")) newCards.push(cardsById["sbp.m10"]);
    if (list.includes("sbp.mpay")) newCards.push(cardsById["sbp.mpay"]);

    return newCards.filter((el) => el) || [];
  };

  const getCryptoMethod = () => {
    API_USER.balance
      .getCryptoMethod({ currency })
      .then((e) => {
        console.log("res", e);
        const data = e.data;
        if (data.list) transformCryptoCard(data.list);
      })
      .catch(console.error);
  };

  const transformCryptoCard = (cryptos) => {
    const cryptoList = [];
    for (let cryptoKey in cryptos) {
      const cryptoBody = cryptos[cryptoKey];
      const ticker = cryptoBody.ticker;

      const newCrypto = {
        id: cryptoKey,
        title: cryptoTitleByTicker[ticker] || "",
        img: cryptoImgByTicker[ticker] || ""
      };
      cryptoList.push(newCrypto);
    }

    setCryptoCard(cryptoList);
  };

  useEffect(() => {
    if (!loader && cards.length == 0) {
      dispatch(setLockBalanceClose(false));
    }
  }, [cards, loader]);

  /**
   * @description - получение списка методов
   */
  useEffect(() => {
    setLoader(true);

    if (TEST_MODE) {
      setLoader(false);
      const list = ["qrc", "card", "sbp", "crypgt", "alpha", "acc", "card.LEMON"];
      const cards = list?.map((el) => cardsById[el]) || [];
      setCard(cards.filter((el) => el) || []);
      transformCryptoCard(testCryptoWallet.list);
      return;
    }

    API_USER.balance
      .method({ amount, currency })
      .then((e) => {
        if (DEBUG) console.log(e);
        const data = e.data;
        const list = data?.list;

        if (list.includes(cryptoType)) getCryptoMethod();

        if (currency === ENUM_CURRENCY.AZN) {
          setCard(addMethodAZN(list));
          return;
        }
        const cards = list?.map((el) => cardsById[el]) || [];
        setCard(cards.filter((el) => el) || []);
      })
      .catch(console.error)
      .finally(() => {
        setLoader(false);
      });
  }, [amount, currency]);

  /**
   * @description - выбор нужного метода
   */
  const onCardClick = (method) => {
    const data = { amount, currency, method };
    setMethodDataPay({ method: ENUM_BALANCE_TYPE.fiat, data });
    setStep(3);
  };

  /**
   * @description - при клике на крипту
   */
  const onCryptoCardClick = (method) => {
    const data = { currency, wallet: method };
    setMethodDataPay({ method: ENUM_BALANCE_TYPE.crypto, data });
    setStep(3);
  };

  return (
    <LoaderContainer loader={loader} center>
      {cards?.length || cryptoCard?.length ? (
        <div className="top-up-balance__cards-content">
          <div className="top-up-balance__cards">
            {cards.map((card, indx) => (
              <div key={indx} className="card" onClick={() => onCardClick(card.id)}>
                <img src={card.img} />
                <span>{t(card.title)}</span>
              </div>
            ))}
          </div>
          <ShowContainer condition={cryptoCard.length}>
            <h3>
              {t("You can also top up your balance with ANY AMOUNT through any crypto network.", {
                currency: currency
              })}
            </h3>
            <div className="top-up-balance__cards">
              {cryptoCard.map((card, indx) => (
                <div key={indx} className="card" onClick={() => onCryptoCardClick(card.id)}>
                  <img src={card.img} />
                  <span>{t(card.title)}</span>
                </div>
              ))}
            </div>
          </ShowContainer>
        </div>
      ) : (
        <div className="top-up-balance__cards__empty">
          <h3>{t("No methods available")}</h3>
        </div>
      )}
    </LoaderContainer>
  );
}
